import { flattenDeep, orderBy } from 'lodash';
import { ILine } from '../models/line.model';
import { IVersionedLine } from '../models/versioned-line.model';
import { DateTime } from 'luxon';
import { LineHelper } from './line.helper';
import { TransportModeHelper } from './transport-mode.helper';

export class VersionedLineHelper {
  public static flattenAndFilterLinesData(lines: IVersionedLine[], q: string, maxNumberOfAutocompleteSuggestions: number, filterResults?: (line: ILine) => boolean): ILine[] {
    // Flatten lines and filter out expired versions
    const flattenedBusinessModels = flattenDeep(lines.map((v) => v.versions ?? []));
    const now = DateTime.now();
    const notExpiredVersions = flattenedBusinessModels.filter((v) => v.appliesUpto == null || v.appliesUpto >= now);
    const onlyRelevantVersions = LineHelper.getRelevantLines(notExpiredVersions);
    const filteredResults = filterResults ? onlyRelevantVersions.filter(filterResults) : onlyRelevantVersions;
    let orderedLines: ILine[];

    if (isNaN(parseInt(q.charAt(0), 10))) {
      const qLower = q.toLowerCase();
      orderedLines = filteredResults;
      orderedLines.sort((a, b) => {
        const ai = a.shortName.toLowerCase().indexOf(qLower);
        const bi = b.shortName.toLowerCase().indexOf(qLower);
        return (ai > -1 ? ai : 9999) - (bi > -1 ? bi : 9999);
      });
    } else {
      orderedLines = orderBy(filteredResults, [(l) => parseInt(l.shortName, 10), (l) => TransportModeHelper.getSortIndexForTransportMode(l.transportMode), (l) => l.technicalLineNumber]);
    }
    return orderedLines.slice(0, maxNumberOfAutocompleteSuggestions);
  }
}
